module.exports = "data:image/webp;base64,UklGRugAAABXRUJQVlA4WAoAAAAQAAAADQAAFwAAQUxQSHYAAAABd6AokqQ2ejnDCxSgjYgIWMzr8f18ZOeCm9q2negQXGAgOUACCxFIwAs+fkWNBCqQkJm5Jn6yENF/tW3bME7RJB8ylQB8JrGRCptLSwaMUu0hcaDGgUxqESrx0FrsMjabFmCQeuDQmgfUM65GC3BU+DsqcwcAVlA4IEwAAAAwAwCdASoOABgAPm0skkWkIqGYBABABsSxAE6ZQj2UHf8AAP77IYRphQlYoNUhIBJVHudvKp1J7pY8r7uv6KJWx6OQejN1j/VDBAAA"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/arrow.webp
// module id = T9/b
// module chunks = 3